import { render } from "./PersonasFooterCounter.vue?vue&type=template&id=75f210e8&scoped=true"
import script from "./PersonasFooterCounter.vue?vue&type=script&lang=js"
export * from "./PersonasFooterCounter.vue?vue&type=script&lang=js"

import "./PersonasFooterCounter.vue?vue&type=style&index=0&id=75f210e8&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75f210e8"]])

export default __exports__